import { BfMetricTileSize, BfMetricTileType, IBfMetricListItem, StandardMetrics, UnitSystem } from '@trackman/baseball-shared-components';
import { action, computed, IObservableArray, makeObservable, observable } from 'mobx';
import { IFeatureConfigService } from '../services/FeatureConfigService';

const getUnitSystem = () => {
  return localStorage.getItem(storageKey) as UnitSystem;
};

const storageKey = 'choosenUnitSystem';
const metricsKey = 'taggingappmetrics-v2';
const metricsVersionKey = 'taggingapp-metrics-version';

export class MetricStore {
  @observable isStrikeZoneDecisionEnabled: boolean;

  constructor(featureConfigService: IFeatureConfigService) {
    this.isStrikeZoneDecisionEnabled = featureConfigService.getConfig().isRoboUmpEnabled;
    this.initializeMetricsFromLocalStorage();
    makeObservable(this);
  }

  @observable tileSize: BfMetricTileSize = BfMetricTileSize.Medium;

  @observable isSettingsMenuVisible = false;

  @observable metrics: IBfMetricListItem[] = [...StandardMetrics];

  @observable metricsVersion = '1.5';

  @computed({ keepAlive: true }) get filteredMetrics() {
    return this.metrics.filter(
      (m) =>
        (m.type !== BfMetricTileType.strikeZoneDecision || this.isStrikeZoneDecisionEnabled) && m.type !== BfMetricTileType.strikeZone3d
    );
  }

  @action setIsStrikeZoneDecisionEnabled = (isRoboUmpEnabled: boolean) => {
    this.isStrikeZoneDecisionEnabled = isRoboUmpEnabled;
  };

  @observable unitSystem: UnitSystem = getUnitSystem() ? getUnitSystem() : UnitSystem.Imperial;

  @action initializeMetricsFromLocalStorage = () => {
    const clientVersion = localStorage.getItem(metricsVersionKey);
    if (clientVersion !== this.metricsVersion) {
      localStorage.setItem(metricsKey, JSON.stringify(StandardMetrics));
      this.metrics = StandardMetrics;
      this.setMetricsVersion();
      return;
    }

    const storedMetrics = localStorage.getItem(metricsKey);
    const storedMetricsSize = localStorage.getItem('taggingappmetricsize');
    if (storedMetrics) {
      const parsedMetrics = JSON.parse(storedMetrics) as IBfMetricListItem[];
      const fullMetrics = [...parsedMetrics, ...StandardMetrics.filter((m) => !parsedMetrics.some((p) => p.id === m.id))];
      this.metrics = fullMetrics;
    }
    if (storedMetricsSize) {
      this.tileSize = JSON.parse(storedMetricsSize);
    }
  };

  @action setMetricsVersion = () => {
    localStorage.setItem(metricsVersionKey, this.metricsVersion);
  };

  @action setMetrics = (newOrder: IBfMetricListItem[]) => {
    (this.metrics as IObservableArray).replace(newOrder);
    localStorage.setItem(metricsKey, JSON.stringify(this.metrics));
  };

  @action setTileSize = (size: BfMetricTileSize) => {
    this.tileSize = size;
    localStorage.setItem('taggingappmetricsize', JSON.stringify(this.tileSize));
  };

  @action setIsSettingsMenuVisible = (isVisible: boolean) => {
    this.isSettingsMenuVisible = isVisible;
  };

  @action setUnitSystem = async (choosenUnitSystem: UnitSystem) => {
    localStorage.setItem(storageKey, choosenUnitSystem);
    this.unitSystem = choosenUnitSystem;
  };
}
